app.service('resolverService', ['crudService', '$q', '$location', '$injector', '$ocLazyLoad', '$timeout', 'configService', 'accountSM', function (crudService, $q, $location, $injector, $ocLazyLoad, $timeout, configService, accountSM) {
    function Checker(url) {
        this.method = 'post';
        this.url = url;
        this.params = {
            url: [],
            asso: []
        };
        this.verif = 1;
        this.callback = function ($location) {
            $location.url('/');
        };
        this.only_allow = false;
        this.cache = null;
    }

    Checker.prototype = {
        setMethod: function (method) {
            this.method = method;
            return this;
        },
        setCache: function (service, key) {
            this.cache = {
                service: service,
                key: key
            };
            return this;
        },
        setVerif: function (verif) {
            this.verif = verif;
            return this;
        },
        /**
         *
         * @param params
         * @param [via_url=1] bool
         * @returns {Checker}
         */
        setParams: function (params, via_url) {
            if (typeof via_url == 'undefined') via_url = 1;

            if (via_url) this.params.url = params;
            else this.params.asso = params;
            return this;
        },
        setVerifKo: function (callback) {
            this.callback = callback;
            return this;
        },
        onlyAllow: function (bool) {
            this.only_allow = bool;
            return this;
        },
        makeUrl: function ($stateParams) {
            var url = this.url;
            angular.forEach(this.params.url, function (value, key) {
                if (!angular.isNumber(value)) url = url.replace('{' + key + '}', $stateParams[value]);
            });
            return url;
        },
        makeParams: function ($stateParams) {
            var res = {};
            angular.forEach(this.params.url, function (value, key) {
                if (angular.isNumber(key)) res[value] = $stateParams[value];
            });
            angular.forEach(this.params.asso, function (value, key) {
                res[key] = value;
            });

            return res;
        },
        call: function ($state, $stateParams) {
            var self = this;

            return crudService[self.method](self.makeUrl($stateParams), self.makeParams($stateParams)).then(function (allow) {
                if (self.cache) $injector.get(self.cache.service).put(self.cache.key, !!allow);
                if (allow == self.verif) return $q.resolve('allow');
                else self.callback($location, $state);

                if (self.only_allow) return $q.resolve('allow');
                else return $q.reject('deny');
            });
        }
    };

    return {
        /**
         * Charge en layloading un tableau de fichiers
         * @param  files
         * @return
         */
        files: function (files) {
            if (configService.getVersion()) {
                // Si il y a une version (timestamp)
                var filesVersion = [];
                angular.forEach(files, function (value) {
                    this.push(value + '?v=' + configService.getVersion());
                }, filesVersion);
                files = filesVersion;
            }

            return $ocLazyLoad.load({
                files: files
            });
        },
        /**
         * Permet
         *
         * @param $state
         * @param $stateParams
         */
        pwdTemporary: function ($state, $stateParams) {
            return new Checker('/account/password_temporary/check').setVerif(0).onlyAllow(true).setVerifKo(function ($location, $state) {
                $timeout(function () {
                    $state.go('app.account', {tab: 'pwd-reset'});
                }, 1000);
            }).call($state, $stateParams);
        },
        /**
         * Permet
         *
         * @param $state
         * @param $stateParams
         */
        pwdDeprecated: function ($state, $stateParams) {
            return new Checker('/account/password_deprecated/check').setVerif(0).onlyAllow(true).setVerifKo(function ($location, $state) {
                $timeout(function () {
                    $state.go('app.account', {tab: 'pwd-reset'});
                }, 1000);
            }).call($state, $stateParams);
        },
        /**
         * Permet de définir si nous devons être connecté ou nous devons pas
         * @param need_connected
         * @param $state
         * @param $stateParams
         * @returns {Function}
         */
        auth: function (need_connected, $state, $stateParams) {
            return new Checker('/loggedin').setVerif(need_connected).setVerifKo(function ($location, $state) {
                if (need_connected) {
                    $timeout(function () {
                        $state.go('auth.login', {'redirectTo': $location.url()});
                    }, 750);
                } else {
                    if ($location.url().includes('password/reset')) {
                        window.location.href = '/logout?reset=1';
                    } else {
                        $state.go('app.home');
                    }
                }
            }).setMethod('get').setCache('userCache', 'connected').call($state, $stateParams);
        },
        /**
         * Permet de vérifié si nous avons le droit de voir ce contrat
         */
        contrat: function ($state, $stateParams) {
            return new Checker('/contrat/{contratId}/check').setParams({'contratId': 'contrat_id'}).call($state, $stateParams);
        },
        /**
         * Permet de vérifié si nous avons le droit de voir un site
         */
        site: function ($state, $stateParams) {
            return new Checker('/site/{siteId}/check').setParams({'siteId': 'site'}).call($state, $stateParams);
        },
        /**
         * Permet de vérifié si nous avons le droit de voir la feature
         * @returns {*}
         */
        feature: function (slug, $state, $stateParams) {
            return new Checker('/contrat/{contratId}/' + slug + '/checkFeature').setParams({'contratId': 'contrat_id'}).call($state, $stateParams);
        },
        allowSign: function (slug, feature, $state, $stateParams) {
            return new Checker('/contrat/{contratId}/' + slug + '/' + feature + '/{id}/check').setParams({
                'contratId': 'contrat_id',
                'id': 'id'
            }).call($state, $stateParams);
        },
        isAdminClient: function ($state, $stateParams) {
            return new Checker('/client_account/check').setVerifKo(function ($location) {
                $location.url('/app/home');
            }).setMethod('get').call($state, $stateParams);
        }
    };
}]);